import { useMutation } from "@tanstack/react-query";
import type { AxiosError } from "axios";

import { httpService } from "~/core/http_service";

import type { UpdateProfilePicturePayload } from "../types";

type UpdateProfilePictureInput = {
  userId: number;
  payload: UpdateProfilePicturePayload;
};

const updateProfilePicture = ({ userId, payload }: UpdateProfilePictureInput): Promise<unknown> => {
  return httpService.request({
    url: `/users/update/profile/picture/${userId}/`,
    method: "PATCH",
    payload,
  });
};

export const useUpdateProfilePicture = () => {
  return useMutation<unknown, AxiosError, UpdateProfilePictureInput>({
    mutationKey: ["users", "profile-picture"],
    mutationFn: updateProfilePicture,
  });
};
